import { createStore, compose, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { reducer as reduxFormReducer } from 'redux-form'
import user from './reducers/user'
import userAsAdmin from './reducers/user-as-admin'
import emails from './reducers/emails'
import loading from './reducers/loading'
import errors from './reducers/errors'
import redirectUriAfterLogin from './reducers/redirect-uri-after-login'
import redirecting from './reducers/redirecting'
import otpsPosted from './reducers/otps-posted'
import { CLIENT_INIT } from './actions/client-only'

const reducer = combineReducers({
  form: reduxFormReducer,
  user: user,
  userAsAdmin,
  emailState: emails,
  loading: loading,
  error: errors,
  redirectUriAfterLogin,
  redirecting,
  otpsPosted,
  clientFullyInitialised: (state = false, action) => {
    if (action.type == CLIENT_INIT) {
      return true
    }
    return state
  }
})

module.exports = {
  configureStore: (initialState) => {
    return createStore(reducer, initialState, compose(
      applyMiddleware(
        // middleware to dispatch CLIENT_INIT... so that we know on the client,
        // if redux is fully initialised.
        store => next => action => {
          if (!store.getState().clientFullyInitialised
            && typeof window != 'undefined'
            && window.document) {
            next({ type: CLIENT_INIT })
          }
          return next(action)
        },
        thunk
      ),
      // activates Chrome dev tools, see https://github.com/zalmoxisus/redux-devtools-extension
      (typeof window !== 'undefined' && window.devToolsExtension)
        ? window.devToolsExtension()
        : f => f

    ))
  }
}



// WEBPACK FOOTER //
// ./src/app/redux-store.js